import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { IChatBotV2ConfigPregunta, IChatBotV2Response, IChatBotV2RespuestaAceptacionTYC, IChatBotV2SesionesResponse, IChatBotV2SessionResponse, IEstadoChatBotV2Response } from '../../models/chat-bot-v2.model';
import { IFeedBackGenerado, IHistorial, IRespuestaBot } from '../../models/chat-bot.model';

@Injectable({
  providedIn: 'root'
})
export class ChatBotV2Service {

  apiUrl: string = environment.ENDPOINTS.MS.MS_CHATBOT;

  constructor(
    private http: HttpClient,
  ) { }

  evaluarEstadoChatBot() {
    const URL = `${this.apiUrl}/operaciones/evaluar-estado-chatbot`;
    return this.http.get<IEstadoChatBotV2Response>(URL).toPromise();
  }

  crearSesion() {
    const URL = `${this.apiUrl}/operaciones/crear-sesion`;
    return this.http.post<IChatBotV2SessionResponse>(URL, {}).toPromise();
  }

  eliminarSesion(sesionId: string) {
    const URL = `${this.apiUrl}/operaciones/eliminar-sesion`;
    return this.http.delete<IChatBotV2SessionResponse>(URL, { params: { sesionId } }).toPromise();
  }

  enviarMensaje(pregunta: string, config: IChatBotV2ConfigPregunta, documents: any[] = []): Promise<IRespuestaBot> {
    const URL = `${this.apiUrl}/operaciones/enviar-mensaje`;
    const formData = new FormData();

    formData.append('pregunta', pregunta);

    Object.entries(config).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (typeof value === 'object') {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, String(value));
        }
      }
    });
    documents.forEach(file => {
      formData.append('documentos', file);
    });

    return this.http.post<IRespuestaBot>(URL, formData).toPromise();
  }

  obtenerHistorial(sesionId: string) {
    const URL = `${this.apiUrl}/operaciones/obtener-detalle-sesion`;
    return this.http.get<IChatBotV2Response>(URL, { params: { sesionId } }).toPromise();
  }

  enviarFeedBack(comentario: string, historial: IHistorial[], idLenguaje, topico: string, usuario: string) {
    const URL = `${this.apiUrl}/operaciones/enviar-feedback`;
    const body: IFeedBackGenerado = {
      comentario: comentario,
      historial: historial,
      languageId: idLenguaje,
      topico: topico,
      usuario: usuario
    }
    return this.http.post(URL, body).toPromise();
  }

  enviarFeedBackGlobal(mensaje: string, evaluacion: string) {
    const URL = `${this.apiUrl}/operaciones/enviar-feedback-global`;
    return this.http.post(URL, {mensaje, evaluacion}).toPromise();
  }

  obtenerAceptacionTYC() {
    const URL = `${this.apiUrl}/operaciones/obtener-marca-tyc`;
    return this.http.get<IChatBotV2RespuestaAceptacionTYC>(URL).toPromise();
  }

  guardarAceptacionTYC(acepta: boolean) {
    const URL = `${this.apiUrl}/operaciones/marcar-tyc`;
    return this.http.post(URL, { acepta }).toPromise();
  }

  obtenerSesiones() {
    const URL = `${this.apiUrl}/operaciones/obtener-sesiones`;
    return this.http.get<IChatBotV2SesionesResponse>(URL).toPromise();
  }

}
